import React, { Component } from 'react'
import styled from 'styled-components'
import { MEDIA_BASE_URL } from 'config'
import grayscaleImage from './images/grayscale.svg'

class DivisionNavbarItem extends Component {
  componentDidMount () {
    this.props.onComponentLoaded && this.props.onComponentLoaded()
  }

  render () {
    const {className, icon, title, selected, onClick} = this.props

    return (
      <Container className={className} onClick={onClick} selected={selected}>
        {icon && <Image src={MEDIA_BASE_URL + icon} alt={title} selected={selected} gray={grayscaleImage} />}
        <Title selected={selected}>{title}</Title>
      </Container>
    )
  }
}

export default DivisionNavbarItem

const Container = styled.div`
  display:inline-block;
  width: 60px;
  position: relative;
  background-color: #FFFFFF;

  flex: 1 1 auto;
  color: #676767;
  opacity: 0.6;

  ${({selected}) => selected && `
    opacity: 1.0;
  `}

  margin-left: 10px;
  margin-right: 10px;

  &:first-child {
    margin-left: 0px;
  }

  &:last-child {
    margin-right: 0px;
  }

  transition: opacity 0.2s ease-in, color 0.2s ease-in;
  text-align:center;

  &:hover {
    > img {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
      filter: url("${({gray}) => gray}#greyscale");
    }
    > span {
      color: #3E3E3E;
    }
    opacity: 1.0;
  }
`

const Image = styled.img`
  display: block;
  transition: filter 0.2s ease-in;
  width: 35px;
  height: 35px;
  margin: 0 auto;

  ${({selected}) => selected && `
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
    filter: url("${({gray}) => gray}#greyscale");
  `}


`

const Title = styled.span`
  -webkit-transition: color 0.2s ease-in;
  -moz-transition: color 0.2s ease-in;
  -ms-transition: color 0.2s ease-in;
  -o-transition: color 0.2s ease-in;
  transition: color 0.2s ease-in;

  color: #676767;

  ${({selected}) => selected && `
    color: #3E3E3E;
  `}
  display: inline-block;

  font-family: Nunito;
  font-size: 12px;
  font-weight: bold;
  line-height: 12px;
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/DivisionNavbarItem/index.js